<template>
  <div>
    <div class="document">
      <!-- <img src="../../../assets/img/logo/NAN_logomark_RGB_Evergreen.png" alt="" class="center" style="width: 110px; padding-bottom: 10px;"> -->
      <h3 style="text-align: center;">TRANSPORTATION CONSENT FORM</h3>
      <hr>
      <!-- <p>Parent(s): {{ document.field1 }} (hereinafter, the "Parents")</p> -->
      <!-- <p>Child/ren: {{ document.field2 }} (hereinafter, the "Children")</p> -->
      <!-- <pre v-html="document.body" class="mt-3"></pre> -->
      <p>We, {{ document.field1 }} (parents) of {{ document.field2 }} (child/ren), do hereby authorize and direct the scheduled employee of The Nanny Company to transport our child(ren) to and from the frequent pick-up points and/or any other designated destinations, within reason. All transportation is to be consented of in advance by the parents.</p>
      <p>Further, the Employee has agreed to comply with the Employee Handbook, including that there will be no cell phone use while driving with the child/ren, they have a valid drivers license, and will regularly maintain the reliable vehicle, with the appropriate insurance. The Clients will ensure the car seats are installed properly and the Employee will use them accordingly.</p>
      <p>We understand and acknowledge that The Nanny Company Inc. assumes no responsibility, obligation or liability of any kind.</p>
      <hr>
      <p v-if="document.status == 'Unsigned'">{{ new Date().toDateString() }}</p>
      <p v-if="document.status == 'Signed'">{{ new Date(document.signing_date).toDateString() }}</p>
      <h4 v-if="signature" style="font-family: 'Arizonia'">{{ signature }}</h4>
      <h4 v-if="!signature">___________</h4>
      <p v-if="document.status == 'Signed'">{{ document.signing_name }}</p>
      <div v-if="!document.signing_name">
        <input type="text" class="form-control" v-model="signature" style="max-width: 500px;">
        <label class="mt-1">Signature of Parent/Guardian (Please Type)</label>
        <div>
          <button v-if="!signature" class="mylisting-button disabled-button mt-3" style="cursor: not-allowed; color: gray;" @click.prevent="">Sign</button>
          <button v-if="signature" class="mylisting-button dark-button mt-3" @click="sign()">Sign</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['document'],
  data() {
    return {
      signature: '',
    }
  },
  created() {
    this.signature = this.document.signing_name
  },
  methods: {
    sign() {
      axios.patch(`/api/documents/${this.document.id}/`, {
        signing_name: this.signature,
        signing_date: this.todayDatetimeDjangoFormat,
        status: 'Signed',
      })
        .then(res => {
          console.log(res)
          this.$emit('documentSigned')
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/employers/documents/TransportationConsent.vue